import React from 'react';
import { Check, Link as LinkIcon, MessageCircle, Mail, Share2 } from 'lucide-react';

/**
 * Step 4 — Share/save card.
 *
 * Lets the user copy a deep link to the current cart, share via WhatsApp,
 * or email the configuration to themselves. The deep link contains a
 * Base64-encoded cart token under `?cfg=` that re-hydrates on next load.
 */
export default function ShareCard({ t, copied, shareUrl, onCopy, shareMessage }) {
  if (!shareUrl) return null;
  return (
    <div data-testid="cfg-share-card" className="mb-7 rounded-2xl bg-[#FAF8F2] border border-[#E5E0D2] p-5">
      <div className="flex items-start gap-3">
        <span className="inline-flex w-10 h-10 rounded-full bg-[#7FC242]/15 text-[#3D5F1F] items-center justify-center shrink-0">
          <Share2 className="w-5 h-5" />
        </span>
        <div className="flex-1 min-w-0">
          <p className="text-[14.5px] font-semibold text-[#1F1D1A] leading-snug">{t.shareTitle}</p>
          <p className="text-[12.5px] text-[#5C5852] leading-snug mt-1">{t.shareSub}</p>
        </div>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={onCopy}
          data-testid="cfg-share-copy"
          className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-[12.5px] font-semibold transition-colors ${
            copied
              ? 'bg-[#7FC242] text-white'
              : 'bg-[#1F1D1A] text-white hover:bg-[#F26B1A]'
          }`}
        >
          {copied ? <Check className="w-3.5 h-3.5" /> : <LinkIcon className="w-3.5 h-3.5" />}
          {copied ? t.shareCopied : t.shareCopy}
        </button>
        <a
          href={`https://wa.me/?text=${encodeURIComponent(shareMessage)}`}
          target="_blank"
          rel="noreferrer"
          data-testid="cfg-share-wa"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-[#E5E0D2] text-[#1F1D1A] text-[12.5px] font-semibold hover:border-[#F26B1A] hover:text-[#F26B1A] transition-colors"
        >
          <MessageCircle className="w-3.5 h-3.5" /> {t.shareWA}
        </a>
        <a
          href={`mailto:?subject=${encodeURIComponent(t.shareTitle)}&body=${encodeURIComponent(shareMessage)}`}
          data-testid="cfg-share-mail"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border border-[#E5E0D2] text-[#1F1D1A] text-[12.5px] font-semibold hover:border-[#F26B1A] hover:text-[#F26B1A] transition-colors"
        >
          <Mail className="w-3.5 h-3.5" /> {t.shareMail}
        </a>
      </div>
    </div>
  );
}
